module.exports = "/fonts/vendor/quasar-extras/fontawesome/fa-solid-900.woff?bcb927a742a8370b76642fd1a9a749c0";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/fontawesome/fa-solid-900.woff
// module id = mZuE
// module chunks = 49